import { render, staticRenderFns } from "./DownloadLeadPDF.vue?vue&type=template&id=2f7c4212&scoped=true"
import script from "./DownloadLeadPDF.vue?vue&type=script&lang=ts"
export * from "./DownloadLeadPDF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c4212",
  null
  
)

export default component.exports